module.exports = __webpack_public_path__ + "static/media/itunes.487ca032.svg";